// Entry point for the build script in your package.json
import '@activeadmin/activeadmin'
import './active_admin/controllers'

// Override default theme to light so active_admin doesn't automatically set the theme based on system preference
window.localStorage.setItem('theme', 'light')
